module.exports = __webpack_public_path__ + "static/media/random_9.19ca9baa.png";